import { render } from "./StockDashboard.vue?vue&type=template&id=0693bb07&ts=true"
import script from "./StockDashboard.vue?vue&type=script&lang=ts"
export * from "./StockDashboard.vue?vue&type=script&lang=ts"

import "./StockDashboard.vue?vue&type=style&index=0&id=0693bb07&lang=scss"

import exportComponent from "/Users/edvardaskostkevicius/WebstormProjects/rv_frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__